import { useTheme } from "react-jss";
import { CustomTableList } from "../../../../dailyCharge/customTableList/tableList";
import { DefaultValues } from "../../../../../../common/enum/DefaultValues";
import { StatisticsOperatorIncidenceDetailedListIncidenceTypeItemStyle } from "./incidenceTypeStyle.jss";

interface IStatisticsOperatorIncidenceDetailedListIncidenceTypeItemProps {
    incidenceTypeGroup: {
        incidenceType: string;
        items: any[];
    };
    index: number;
}

export const StatisticsOperatorIncidenceDetailedListIncidenceTypeItem = ({
    incidenceTypeGroup,
    index,
}: IStatisticsOperatorIncidenceDetailedListIncidenceTypeItemProps) => {
    const theme = useTheme();
    const style = StatisticsOperatorIncidenceDetailedListIncidenceTypeItemStyle({ theme });

    const bodyContent = incidenceTypeGroup.items.map((item, itemIndex) => {
        return (
            <div className="row" key={itemIndex}>
                <div className={style.incidenceType}>
                    {itemIndex === 0 ? incidenceTypeGroup.incidenceType ?? DefaultValues.EMPTY_LIST : null}
                </div>
                <div className="separator">
                    <div className="cell">{item.certificateNumber ?? DefaultValues.EMPTY_LIST}</div>
                    <div className="cell">
                        <span className={style.description}>{item.organism ?? DefaultValues.EMPTY_LIST}</span>
                    </div>
                    <div className="cell">{item.transportUnitNumber ?? DefaultValues.EMPTY_LIST}</div>
                    <div className="cell">{item.entityName ?? DefaultValues.EMPTY_LIST}</div>
                </div>
            </div>
        );
    });

    return (
        <div className={style.container}>
            {index > 0 && <div className={style.separator}></div>}
            <CustomTableList bodyContent={bodyContent} />
        </div>
    );
};
